'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'universal-cookie';

const DataDogRUM = () => {
  useEffect(() => {
    const cookies = new Cookies();
    const isNativeApp = cookies.get('in_native_app');
    const configuration = {
      applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'my-nerdwallet-next',
      env: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
      version: process.env.NEXT_PUBLIC_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      beforeSend: (event) => {
        event.context.userSource = isNativeApp ? 'nw-native-app' : 'nw-web';
        return true;
      },
    };
    if (
      process.env.NEXT_PUBLIC_DATADOG_APP_ID &&
      process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    ) {
      datadogRum.init(configuration);
    }
  }, []);

  return null;
};

export { datadogRum };
export default DataDogRUM;
